import { colorMapMarker } from "@rio-cloud/rio-uikit/Polygon";

const STROKE_COLOR = colorMapMarker["color-map-marker-geofence"].stroke;
const FILL_COLOR = colorMapMarker["color-map-marker-geofence"].fill;
const INTEREST_STROKE_COLOR = colorMapMarker["color-map-marker-success"].stroke;
const INTEREST_FILL_COLOR = colorMapMarker["color-map-marker-success"].fill;
const AVOID_STROKE_COLOR = colorMapMarker["color-map-marker-danger"].stroke;
const AVOID_FILL_COLOR = colorMapMarker["color-map-marker-danger"].fill;

/**
 * Retorna o estilo (cores de preenchimento e borda) baseado no tipo do marcador.
 * Para tipo "interest" retorna cores de sucesso (verde),
 * para "avoid" retorna cores de perigo (vermelho),
 * e para outros casos retorna as cores padrão de geofence.
 */
export const getStyleByType = (type: "interest" | "avoid") => {
    if (type === "interest") {
        return { strokeColor: INTEREST_STROKE_COLOR, fillColor: INTEREST_FILL_COLOR };
    } else if (type === "avoid") {
        return { strokeColor: AVOID_STROKE_COLOR, fillColor: AVOID_FILL_COLOR };
    }
    return { strokeColor: STROKE_COLOR, fillColor: FILL_COLOR };
};